export default __webpack_public_path__ + "static/media/banners_gifts.faf43097.png";